/** Vuex kaynak: store/modules/planManager.js state — micro-7-2 */
export function createPlanManagerState() {
    return {
        savedPlans: {},
        directoryHandle: null,
        analysisData: null,
        currentMethod: null,
        dolulukHedefi: null,
        optimizasyonParametreleri: null,
        analizSonuclari: null,
        seferPlani: null,
        gidisVerileri: {
            servisler: [],
            istatistikler: {},
            optimizasyonSonuclari: {},
            yolcuSayilari: [],
            duraklar: [],
            hatBilgileri: {},
            grafikVerileri: {},
        },
        donusVerileri: {
            servisler: [],
            istatistikler: {},
            optimizasyonSonuclari: {},
            yolcuSayilari: [],
            duraklar: [],
            hatBilgileri: {},
            grafikVerileri: {},
        },
        hatVerileri: {
            gidis: {},
            donus: {},
            gidisDuraklar: [],
            donusDuraklar: [],
            duraklar: [],
        },
        yolcuVerileri: {
            gidis: [],
            donus: [],
            toplam: {},
        },
        grafikVerileri: {
            gidis: {},
            donus: {},
            toplam: {},
        },
        modelVerileri: {
            gidis: {},
            donus: {},
            toplam: {},
        },
    };
}
